import {TagsEditModalForm} from './TagsEditModalForm'

const TagsEditModalFormWrapper = () => {
  return <TagsEditModalForm />
}

export {TagsEditModalFormWrapper}
